import { InterfaceMonitoringStatusPolicy } from "constants/document/InterfaceMonitoringStatusPolicy";

export const InterfaceMonitoringStatusDroOpts = () => {

    const getAllInvSendingStatusModel = () => {
        let items = [];

        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_SEND);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_POST);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_OK);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_REJECT);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_ERROR);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_RECEIVED);

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    const getEbisInvSendingStatusModel = () => {
        let items = [];

        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_SEND);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_OK);
        items.push(InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_ERROR);

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    return {
        getAllInvSendingStatusModel, 
        getEbisInvSendingStatusModel     
    }
}